import { Modal } from '../../components/Modal';
import { Spinner } from '../../components/Spinner';
import { nf, type Favorito } from './tipos';

/** Pre-análisis del estudio (fases, 2026-07-23): informa; si la carpeta es muy grande advierte y
 *  sugiere acotar, pero el cliente puede insistir y lanzar. */
export function ModalAnalisis({ f, onCerrar, onEstudiar, onQuitar }: { f: Favorito; onCerrar: () => void; onEstudiar: (id: string) => Promise<void>; onQuitar: (id: string) => Promise<void> }) {
  const a = f.analisis;
  const grande = !!a && (a.topeAlcanzado || a.archivos > 600 || a.mb > 1500);
  return (
    <Modal titulo={`Análisis del estudio — ${f.nombre}`} onCerrar={() => onCerrar()}>
        {f.sync_estado === 'analizando' || !a ? (
          <div className="flex flex-col items-center gap-3 py-8">
            <Spinner tamano="md" />
            <p className="text-[13px] font-normal text-gris">Analizando el directorio (sin descargar nada)…</p>
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
              {[
                [nf.format(a.archivos), 'archivos'],
                [`${nf.format(a.mb)} MB`, 'en total'],
                [nf.format(a.imagenes + a.audios), 'imágenes y audios'],
                [a.muyGrandes > 0 ? nf.format(a.muyGrandes) : '0', 'muy grandes (>35MB)'],
              ].map(([v, l]) => (
                <div key={l as string} className="rounded-xl bg-slate-50 px-3 py-2.5 text-center">
                  <p className="text-[17px] font-medium tabular-nums text-azul-profundo">{v}</p>
                  <p className="text-[10.5px] font-light text-gris">{l}</p>
                </div>
              ))}
            </div>

            <div className="rounded-xl border border-slate-200 px-3.5 py-3 text-[12.5px] font-normal leading-relaxed text-texto">
              <p><strong className="font-medium">Fase 1 — estudio de documentos:</strong> ~{a.estFase1Min} min (estimado). Andrés queda operativo al terminar.</p>
              {a.estFase2Min > 0 && (
                <p className="mt-1"><strong className="font-medium">Fase 2 — multimedia (opcional):</strong> ~{a.estFase2Min} min para transcribir {nf.format(a.imagenes)} imágenes y {nf.format(a.audios)} audios. Se lanza después, desde la card del proyecto.</p>
              )}
              {a.muyGrandes > 0 && (
                <p className="mt-1 text-gris">Los {a.muyGrandes} archivos sobre 35MB se catalogan por nombre (sin extraer contenido).</p>
              )}
              <p className="mt-1 text-gris">Si el estudio se interrumpe (reinicios), se reanuda solo desde donde iba.</p>
            </div>

            {grande && (
              <div className="rounded-xl bg-amber-50 px-3.5 py-3 text-[12.5px] font-normal leading-relaxed text-amber-800 ring-1 ring-inset ring-amber-200">
                <p className="font-medium">⚠️ Esta carpeta es muy grande{a.topeAlcanzado ? ` (supera el tope de ${nf.format(2000)} archivos: el estudio quedará incompleto)` : ''}.</p>
                <p className="mt-1">Para un mejor resultado, sugerimos marcar la carpeta específica del proyecto en vez de la carpeta completa. Las subcarpetas con más archivos son:</p>
                <ul className="mt-1.5 list-inside list-disc">
                  {a.subcarpetas.slice(0, 4).map((s) => (
                    <li key={s.nombre}>{s.nombre} <span className="text-amber-700/70">({nf.format(s.archivos)} archivos)</span></li>
                  ))}
                </ul>
                <p className="mt-1.5">De todas formas, puedes estudiarla completa si lo prefieres.</p>
              </div>
            )}

            <div className="flex flex-wrap justify-end gap-2">
              <button
                type="button"
                onClick={() => void onQuitar(f.id)}
                className="rounded-lg px-3.5 py-2 text-[13px] font-normal text-gris transition-colors hover:bg-slate-100 hover:text-red-600"
              >
                Quitar carpeta
              </button>
              <button type="button" onClick={() => onCerrar()} className="rounded-lg px-3.5 py-2 text-[13px] font-normal text-texto transition-colors hover:bg-slate-100">
                Decidir después
              </button>
              <button type="button" onClick={() => void onEstudiar(f.id)} className="btn-primario !text-[13px]">
                🚀 Estudiar {grande ? 'de todas formas' : 'ahora'}
              </button>
            </div>
          </div>
        )}
      </Modal>
  );
}
